import styles from './Modal.scss';

/**
 * Consts used in modal styling
 * Exported so modal's children can use them
 */
export const MAX_MODAL_WIDTH = parseInt(styles.maxModalWidth);
export const OVERLAY_MOBILE_PADDING = parseInt(styles.modalOverlayPaddingMobile) * 2;
export const OVERLAY_DESKTOP_TABLET_PADDING = parseInt(styles.modalOverlayPaddingTablet) * 2;
export const CONTENT_MARGIN = parseInt(styles.modalContentMargin) * 2;
export const MODAL_VIEWPORT_PERCENTAGE = parseInt(styles.modalViewportPercentage) / 100;
